// extracted by mini-css-extract-plugin
module.exports = {"image_wrapper":"image_image_wrapper__1BCdl","image":"image_image__35ngB","image_data":"image_image_data__2qU37"};